import { AppAlert } from '@components/antd';
import { Button } from 'antd';
import { useAppBanner } from './hooks/use-app-banner';

export const MfaSetupReminderBanner = () => {
  const { mfaBanner } = useAppBanner();
  return (
    <AppAlert
      showIcon
      type="warning"
      message={
        <p>
          To help keep your account secure, set up two-factor authentication with an extra verification step.
          <Button
            className="cursor-pointer mx-2.5! text-xs! h-[25.5px]! px-5! rounded-sm!"
            onClick={mfaBanner.handleLater}
            loading={mfaBanner.loading}
          >
            Later
          </Button>
          <Button
            className="cursor-pointer text-xs! h-[25.5px]! px-[5px]! rounded-sm! bg-text-950! text-white!"
            onClick={mfaBanner.handleSetupMFa}
          >
            Setup 2FA
          </Button>
        </p>
      }
    />
  );
};
